import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { InventoryProductListRowProps } from 'features/shared/inventory/types/InventoryProductListRowProps';
import 'features/shared/inventory/InventoryProducts.scss';

/**
 * Desktop products-list row (`hk-desktop-digital-inventory-products-list-item`).
 * Mirrors the `hk-desktop-home-selection-item` row pattern used by home selections.
 */
const InventoryProductListRowDesktop: React.FC<
  InventoryProductListRowProps
> = ({ image, title, modelDisplay, brandDisplay, onClick }) => {
  return (
    <IonItem
      lines="none"
      className="hk-desktop-digital-inventory-products-list-item"
      onClick={onClick}
    >
      <IonLabel className="hk-desktop-digital-inventory-products-list-item-body">
        <div className="hk-desktop-digital-inventory-products-list-item-body-title">
          <div className="hk-desktop-digital-inventory-products-list-item-icon">
            <img src={image} alt="" />
          </div>
          <IonText>
            <p>{title}</p>
          </IonText>
        </div>
        <IonText className="hk-desktop-digital-inventory-products-list-item-body-field">
          <p>{modelDisplay}</p>
        </IonText>
        <IonText className="hk-desktop-digital-inventory-products-list-item-body-field">
          <p>{brandDisplay}</p>
        </IonText>
      </IonLabel>
      <span className="hk-desktop-digital-inventory-products-list-item-marker"></span>
    </IonItem>
  );
};

export default InventoryProductListRowDesktop;
